import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { AccountState } from './models';

const selectAccountState = (state: RootState) => state.account;

export const selectIsLoggedIn  = createSelector(
  [selectAccountState],
  (state: AccountState) => state ? state.isLoggedIn : false
);

export const selectIsAdmin = createSelector(
  [selectAccountState],
  (state: AccountState) => state ? state.isAdmin : false
);

export const selectEmailId = createSelector(
  [selectAccountState],
  (state: AccountState) => state ? state.emailId : null
);

export const selectAccountLoginLoading = createSelector(
  [selectAccountState],
  (state: AccountState) => state ? state.loginLoading : null
);

export const selectAccountLoginLoaded = createSelector(
  [selectAccountState],
  (state: AccountState) => state ? state.loginLoaded : null
);

export const selectAccountLoginErrMsg = createSelector(
  [selectAccountState],
  (state: AccountState) => state ? state.loginErrMsg : null
);

export const selectAccountLogoutSuccess = createSelector(
  [selectAccountState],
  (state: AccountState) => state ? state.logoutSuccess : null
);
